<div class="vd-player" #stage tabindex="-1" [class.is-ad]="adPlaying" (keydown)="onKey($event)" aria-label="Video player">
    <video
        #videoElement
        id="stormcloud-video"
        class="vd-player-video"
        autoplay
        playsinline
        crossorigin="anonymous"
        [attr.poster]="posterImage"
        (loadedmetadata)="onVideoLoaded($event)"
        (error)="loading = false; onVideoError($event)"
        (timeupdate)="getCurrentTime($event)"
        (ended)="ended.emit(); playState.emit('ended')"
        (pause)="playState.emit('paused')"
        (waiting)="loading = true"
        (canplay)="loading = false"
        (playing)="loading = false; playState.emit('playing')"
        (click)="onVideoClick()">
        <source [src]="videoURL" type="application/x-mpegURL" *ngIf="videoURL">
    </video>
    <span class="vd-player-loading" *ngIf="loading && !adPlaying" role="status" aria-label="Loading video"><span class="vd-spinner"></span></span>
    <app-vd-player-controls *ngIf="!adPlaying" [video]="videoElement" [stage]="stage" [theatre]="theatre"
        [title]="selectedVideo?.stage" (theatreToggle)="theatreToggle.emit()">
    </app-vd-player-controls>
</div>
